module.exports = __webpack_public_path__ + "static/media/dima.6b91a68b.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/AdvisorsPartnersTeamResources/dima.png
// module id = 226
// module chunks = 0